import styled from 'styled-components';

const Wrapper = styled.div`
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
